import { useUpdateScreenChatContext } from '$tablet-app/src/app/chat/hooks';
import { useUpdateChatState } from '$tablet-app/src/app/chat/hooks/useUpdateChatState';
import FullScreenLoader from '$tablet-app/src/app/components/FullScreenLoader';
import { MainDrawerScreenProps } from '$tablet-app/src/app/navigation/MainDrawerNavigator';
import { SectionIntroScreen } from '$tablet-app/src/app/screens/SectionIntroScreen';
import { useGetStateVariable } from '$tablet-app/src/app/state_variables';
import { useCalendarInfoVideo } from '$tablet-app/src/app/videos/hooks/info_video_hooks';
import { Button } from '@akin-home/buttons/native';
import { useState } from 'react';
import CalendarScreen from './CalendarScreen';

/**
 * This component wraps the main calendar screen with a intro video that shows if this is the first time the user has viewed the calendar section
 */
export const CalendarScreenVideoWrapper = (
  props: MainDrawerScreenProps<'Calendar'>
) => {
  const update = useUpdateChatState();

  const { data, isLoading } = useGetStateVariable('Screen_calendar_view_count');

  const [continue_pressed, setContinuePressed] = useState(false);

  useUpdateScreenChatContext();

  const { data: info_video, isLoading: videoLoading } = useCalendarInfoVideo();

  const onPressContinue = () => {
    update([
      {
        var_name: 'Screen_calendar_view_count',
        operator: '+=',
        value_type: 'primitive',
        value: '1',
      },
    ]);

    setContinuePressed(true);
  };

  if (isLoading || videoLoading) {
    return <FullScreenLoader />;
  }

  if (
    (!data?.value || data.value === '0') &&
    !continue_pressed &&
    info_video?.value?.length
  ) {
    return (
      <SectionIntroScreen
        screen_title="Calendar"
        video_title="Watch the video and learn about your calendar"
        source={{ drive_id: info_video.value }}
        action_button={
          <Button icon="plus" onPress={onPressContinue}>
            Let's go!
          </Button>
        }
      />
    );
  }

  return <CalendarScreen {...props} />;
};
